import { Component, Input, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { APP_CONFIG } from '@core-app/app.config';
import { BlockAbstractComponent } from '@gallaghercp/core-frontend';

@Component({
  selector: 'coro-mega-card',
  templateUrl: './coro-mega-card.component.html',
  styleUrls: ['./coro-mega-card.component.scss'],
  standalone: false,
  encapsulation: ViewEncapsulation.None,
})
export class CoroMegaCardComponent extends BlockAbstractComponent implements OnInit {
  @Input() cardType?: string;
  @Input() card: any;

  @ViewChild('arrow') arrow!: TemplateRef<any>;
  @ViewChild('pdf') pdf!: TemplateRef<any>;
  @ViewChild('extlink') extlink!: TemplateRef<any>;

  getIconTemplate(iconType: string): TemplateRef<any> {
    switch (iconType) {
      case 'arrow':
        return this.arrow;
      case 'pdf':
        return this.pdf;
      case 'extlink':
        return this.extlink;
      default:
        return this.arrow;
    }
  }

  imageUrl!: string;

  override ngOnInit(): void {
    super.ngOnInit();
    if (this.card) {
      this.block.data = this.card;
    }

    // Set a default value for isLinkWrapped
    if (this.block.data && this.block.data.isLinkWrapped === undefined) {
      this.block.data.isLinkWrapped = false;
    }

    if (this.block?.data?.image_url) {
      this.imageUrl = APP_CONFIG.frontend + this.block.data.image_url;
    }
  }
}
